import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Register the PWA service worker so the app is installable ("Add to home screen").
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch(() => {});
  });
}

// Self-heal a blank screen. If a stale cached index.html points at a JS bundle
// that no longer exists (iOS Safari / installed PWA after a deploy), React
// never mounts and the user just sees a black page that survives refreshes.
// If nothing has rendered after 8s, drop every service worker + cache and
// hard-reload once (guarded by sessionStorage so we can never loop).
const HEAL_KEY = "spc_blank_recovered";
setTimeout(async () => {
  const root = document.getElementById("root");
  if (root && root.childElementCount > 0) return;
  if (sessionStorage.getItem(HEAL_KEY)) return;
  sessionStorage.setItem(HEAL_KEY, "1");
  try {
    if ("serviceWorker" in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((r) => r.unregister()));
    }
    if (window.caches) {
      const keys = await caches.keys();
      await Promise.all(keys.map((k) => caches.delete(k)));
    }
  } catch { /* noop */ }
  window.location.replace(`${window.location.pathname}?r=${Date.now()}`);
}, 8000);

